import {useEffect, useRef, useState} from "react";
import {PageView} from "../enums/PageView";
import HomeShowCase from "../components/others/homeScreen/HomeShowCase";
import {useResizeListener} from "../listeners/SystemResizeListener";
import {recordPageViewMetric} from "../services/AnalyticsRecorder";
import SystemScreenTopBar from "../components/bars/SystemScreenTopBar";
import SystemAppDrawer from "../components/others/SystemAppDrawer";
import HomeFooter from "../components/others/homeScreen/HomeFooter";
import HomeDownloadMobileApp from "../components/others/homeScreen/HomeDownloadMobileApp";
import HomeSectionDivider from "../components/dividers/homeScreen/HomeSectionDivider";
import HomeMission from "../components/others/homeScreen/HomeMission";
import {Helmet} from "react-helmet";
import {buildHelmetTitle} from "../helpers/SeoHelper";

export default function HomeScreen() {
    // Landing Screen used in App to display App purpose and functionalities

    // PROPERTIES
    // ---- PageViewMetric
    const hasTrackedView = useRef(false);
    const [isDrawerOpen, setIsDrawerOpen] = useState(false)

    // HOOKS
    // ---- At rendering : Record page view metric
    useEffect(() => {
        if (!hasTrackedView.current) {
            // Avoid double trigger in dev, due to React Strict mode
            recordPageViewMetric(PageView.LANDING);
            hasTrackedView.current = true;
        }
    }, []);

    // HOOKS
    // ---- Set listener for potential open Modal during screen resize
    useResizeListener(() => setIsDrawerOpen(false))

    // BUILD
    return(
        <div className={"animate-appearSlow bg-backgroundLight1 overflow-auto w-full h-[100svh] flex flex-col justify-start items-center"}>
            {/** META */}
            <Helmet>
                <title>{buildHelmetTitle('Ummia - Bienvenue')}</title>
                <meta name="description"
                      content="L'application pour maitriser les fondamentaux en mathématiques au collège." />
            </Helmet>
            {/** MODAL */}
            <SystemAppDrawer open={isDrawerOpen}
                             handleClose={() => setIsDrawerOpen(false)} />
            {/** CONTENT */}
            <SystemScreenTopBar openDrawer={openDrawer}
                                isForHomeScreen={true} />
            <HomeShowCase />
            <HomeMission />
            <HomeSectionDivider />
            <HomeDownloadMobileApp />
            <HomeFooter />
        </div>
    );

    // METHODS
    // ---- Open modal
    function openDrawer() {
        setIsDrawerOpen(true)
    }
}